// extracted by mini-css-extract-plugin
export var active = "slider-dots-module--active--7e9df";
export var dark = "slider-dots-module--dark--9b2f3";
export var dotButton = "slider-dots-module--dot-button--ea6a8";
export var dotItem = "slider-dots-module--dot-item--44d8d";
export var dotList = "slider-dots-module--dot-list--b5b68";